// install.js — registrazione FLAG-GATED del Cruscotto v3 (F2.3, primo mattone).
// File PURO (niente JSX, niente side-effect): è QUESTO il modulo che il contract
// test server/src/lib/dash-v3-register.test.js esercita sotto node --test.
// La factory React (createDashV3 di Cruscotto.jsx) arriva per parametro:
// il grafo JSX non entra mai nel grafo dei test.
//
// GUARDIE (in ordine, ognuna ⇒ bundle INERTE, return false):
//  1. flag shell_dash_v3 !== '1' (DEFAULT OFF, flags.js) — nessun tocco al registry;
//  2. shell v2 assente (workspace-host legacy al comando / bundle shell 404):
//     serve Workspaces v2 con update/has — kill-switch R1 preservato;
//  3. modulo 'dash' mai registrato (dashboard-module assente/rotto):
//     mai un upgrade orfano.
//
// CANALE: Workspaces.update, NON register. 'dash' a questo punto è GIÀ
// version:2 (upgrade dell'adapter dash-v2, che precede nel manifest) e una
// seconda register v2 sullo stesso id è una COLLISIONE B2.9 (registry.js:87:
// throw in dev). update è il canale v2 per patchare l'entry esistente
// (index.jsx:66): qui sostituisce mount/unmount (il host preferisce mount a
// onShow, host.js:199) e navigate/openDeepLink (che nel v2 delegano a
// __dashShellNav del v1: sotto v3 chiamerebbero onShow → render v1 →
// innerHTML='' SOPRA il DOM React). label/icon/submenu/nav dell'entry
// restano quelli registrati da v1+v2 (merge additivo di update).
//
// ANTI-DOPPIO-BADGE: qui e in tutto client/src/dash-v3/** non si emette MAI
// 'nav:badge' — l'unico emettitore resta bootActionsBadge del v1 (eager),
// che sotto v3 continua a girare senza render (mounted resta false).

import { dashV3Enabled } from '../shell/flags.js';

export function installDashV3(win, createV3) {
  if (!win || !dashV3Enabled(win)) return false; // flag OFF (default): inerte
  const W = win.Workspaces;
  if (!W || W.version !== 2 || typeof W.update !== 'function' || typeof W.has !== 'function') return false;
  if (!W.has('dash')) return false; // v1 mai registrato: mai upgrade orfano
  const v3 = typeof createV3 === 'function' ? createV3(win) : null;
  if (!v3 || typeof v3.mount !== 'function' || typeof v3.unmount !== 'function') return false;
  W.update('dash', {
    mount: v3.mount,
    unmount: v3.unmount,
    navigate: v3.navigate,
    openDeepLink: v3.openDeepLink,
  });
  return true;
}
